import { customerService } from "../../service/customerService"
import { getToken } from "./XsrfToken"

export const GET_ALL_STORE = "GET_ALL_STORE"
export const GET_ALL_STORE_REQUEST = "GET_ALL_STORE_REQUEST"
export const GET_ALL_STORE_SUCCESS = "GET_ALL_STORE_SUCCESS"
export const GET_ALL_STORE_FAILURE = "GET_ALL_STORE_FAILURE"

const initialState = {
	listStore: [],
}

export const getListAllStore = () => (dispatch) => {
	return Promise.resolve()
		.then(() => dispatch(getToken()))
		.then(() =>
			dispatch({
				types: [
					GET_ALL_STORE_REQUEST,
					GET_ALL_STORE_SUCCESS,
					GET_ALL_STORE_FAILURE,
				],
				callAPI: (config) => customerService.getAllStore(config),
			})
		)
		.then((resp) => {
			return resp
		})
}

export default function reducer(state = initialState, action) {
	const { payload, successMessage, errorMessage } = action
	switch (action.type) {
		case GET_ALL_STORE_SUCCESS: {
			return {
				...state,
				listStore: payload,
			}
		}
		case GET_ALL_STORE_FAILURE:

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/Store.js